import React from 'react';
import { useRouter } from 'next/router';
import moment from 'moment';
import { baseUrl } from '../../utils/helpers';
import ServiceNewsletterContainer from '../../components/ServiceProfile/service-newsletter/ServiceNewsletter.container';
import PlanContainer from '../../containers/PlanContainer';
import { Button } from '../../subkit-ui';
import { parseHTMLTemplate } from '../../utils/parse-html-template';
import { AvatarBlurb } from '../AvatarBlurb';
import { Socials } from '../Socials';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * Primary UI component for user interaction
 */
export var PostView = function PostView(_ref) {
  var post = _ref.post,
      provider = _ref.provider,
      service = _ref.service,
      currentUser = _ref.currentUser;
  var templateOptions = {
    shareUrl: ''
  };
  var isLoggedIn = !!(currentUser !== null && currentUser !== void 0 && currentUser.id);

  var _useRouter = useRouter(),
      asPath = _useRouter.asPath;

  var grantorType = post.grantorType;
  var publishedDate = "Published on ".concat(moment(post.publishedAt).format('MMMM DD, YYYY'));

  var getShareUrl = function getShareUrl() {
    if (currentUser !== null && currentUser !== void 0 && currentUser.shareCode) {
      return "".concat(baseUrl, "/").concat(provider.slug, "/r/").concat(currentUser === null || currentUser === void 0 ? void 0 : currentUser.shareCode).toLowerCase();
    }

    return null;
  };

  var shareUrl = getShareUrl();

  if (shareUrl) {
    templateOptions['shareUrl'] = shareUrl;
  }

  var renderedPostBody = parseHTMLTemplate(post.body, templateOptions);
  return /*#__PURE__*/_jsxs("div", {
    className: "flex justify-center flex-col items-center",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "w-full max-w-post-max mx-auto px-4 md:mx-0",
      "data-cy": "post",
      children: [/*#__PURE__*/_jsx("h1", {
        className: "font-serif font-bold mt-28 mb-6 md:mt-32 md:mb-5 text-4xl mx-auto max-w-2xl",
        "data-cy": "post-title",
        children: post.title
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex flex-col md:flex-row mx-auto max-w-2xl justify-between",
        children: [/*#__PURE__*/_jsx(AvatarBlurb, {
          avatarUrl: service.avatarUrl,
          title: provider.name,
          description: publishedDate,
          descriptionStyles: {
            color: '#737373'
          },
          descriptionUrl: "/".concat(provider === null || provider === void 0 ? void 0 : provider.slug)
        }), /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(Socials, {
            service: service,
            user: provider === null || provider === void 0 ? void 0 : provider.user
          })
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "post-body text-lg mt-8 mb-20 max-w-2xl mx-auto",
        "data-cy": "post-body",
        children: renderedPostBody
      }), !grantorType && /*#__PURE__*/_jsx("div", {
        className: "mt-6 w-fill flex justify-center",
        "data-cy": "restrict-body-view",
        children: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("h2", {
            className: "font-serif my-2 text-center",
            "data-cy": "restrict-body-view-title",
            children: "This post is for subscribers only."
          }), /*#__PURE__*/_jsxs("div", {
            className: "text-base max-w-md mx-auto text-center",
            "data-cy": "restrict-body-view-body",
            children: ["Get access to this post and more from ", service === null || service === void 0 ? void 0 : service.name, " when you subscribe today."]
          }), isLoggedIn ? /*#__PURE__*/_jsx("div", {
            className: "py-6",
            children: /*#__PURE__*/_jsx(PlanContainer, {
              providerService: service,
              redirectBack: true,
              post: post,
              planWaitlistIds: []
            })
          }) : /*#__PURE__*/_jsx("div", {
            className: "max-w-full w-64 mx-auto my-12",
            children: /*#__PURE__*/_jsx(Button, {
              text: "Log in to get access",
              href: "/login?redirect=".concat(encodeURIComponent(asPath))
            })
          })]
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "w-full max-w-5xl mx-auto mb-20",
      children: /*#__PURE__*/_jsx(ServiceNewsletterContainer, {
        redirectBack: true,
        service: service
      })
    })]
  });
};